import { params, paramsLegacy } from '../cross-domain-auth.config';
import type { CrossDomainAuthData } from '../cross-domain-auth.types';

type CreateAuthRouteProps = {
  baseUrl: string | URL;
  data: CrossDomainAuthData;
  forLegacy?: boolean;
};

export const createCrossDomainAuthRoute = ({
  baseUrl,
  data,
  forLegacy = false,
}: CreateAuthRouteProps): URL => {
  if (!data.applicationId || !data.token) {
    throw new Error(
      'Both applicationId and token must be provided to create a valid cross-domain auth route.'
    );
  }

  const p = forLegacy ? paramsLegacy : params;
  const url =
    typeof baseUrl === 'string'
      ? new URL(baseUrl, window?.location.href)
      : baseUrl;

  url.searchParams.set(p.applicationId, data.applicationId);
  url.hash = `#${p.token}=${data.token}`;

  return url;
};
